import React from 'react';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import { PaymentMethodLayout } from '../PaymentMethodLayout';
import { CommonMethodProps } from '../types';
import * as s from './styles.scss';
import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { Experiment } from '../../../../types/Experiment';
import { useAdaptedComponents } from '../../../../hooks/useAdaptedComponents';

export const Offline: React.FunctionComponent<
  {
    text?: string;
  } & CommonMethodProps
> = (props) => {
  const text: string = (
    props.text || t('payments.offline.defaultInstructionText')
  ).trim();

  const AdaptedComponents = useAdaptedComponents();

  if (!text) {
    return null;
  }

  const withTitle =
    props.isSinglePaymentOption &&
    experimentsService.isExperimentEnabled(
      Experiment.SinglePaymentMethodViewWithLogo
    );

  if (AdaptedComponents) {
    return (
      <AdaptedComponents.PaymentMethodScreen
        dataHook={DH.PaymentMethod.Offline}
        title={
          withTitle ? (
            <div className={s.title}>
              {t('settings.offlineTitleOptionDefault')}
            </div>
          ) : null
        }
      >
        <span
          className={s.content}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </AdaptedComponents.PaymentMethodScreen>
    );
  }

  return (
    <PaymentMethodLayout
      dataHook={DH.PaymentMethod.Offline}
      theme={props.theme}
    >
      {withTitle && (
        <div className={s.title}>{t('settings.offlineTitleOptionDefault')}</div>
      )}
      <span className={s.content} dangerouslySetInnerHTML={{ __html: text }} />
    </PaymentMethodLayout>
  );
};
Offline.displayName = 'Offline';
